import { BudgetPeriod } from '@webapp/platform/finance'
import { type IExpenseRepository } from '../../interfaces/IExpenseRepository'

interface GetExpenseItemAccountBudgetPeriodParams {
  expenseItemId: number
  accountId: number
}

interface Dependency {
  expenseRepository: Pick<IExpenseRepository, 'getItemBudgetPeriod'>
}

/**
 * Resolves the budget period displayed in the correction form's Budget Date
 * cell after an account is selected (BHV-020).
 */
export class GetExpenseItemAccountBudgetPeriodUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = async ({
    expenseItemId,
    accountId,
  }: GetExpenseItemAccountBudgetPeriodParams): Promise<BudgetPeriod> => {
    const constructor = await this.deps.expenseRepository.getItemBudgetPeriod(
      expenseItemId,
      accountId
    )

    return new BudgetPeriod(constructor)
  }
}
